module.exports = __webpack_public_path__ + "static/img/wx-8.f6369c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wx-8.png
// module id = CD79
// module chunks = 10